import React from 'react';
import { Col } from 'reactstrap';
import ValidateButton from './ValidateButton';
import SaveQuestion from './SaveQuestion';
import ReportQuestion from './ReportQuestion';

function QuestionBankFooter({ validateQuestion, toggleReportSection, favItemId, onSaveItemChange, setChildRef, disabled = false }) {
  return (
    <Col sm={9} xs={12}>
      <div className='d-flex align-items-center mt-2 mb-1'>
        <ValidateButton onValidate={validateQuestion} disabled={disabled} />
        <SaveQuestion favItemId={favItemId} onSaveItemChange={onSaveItemChange} setChildRef={setChildRef} />
        <ReportQuestion onClick={toggleReportSection} />
      </div>
    </Col>
  );
}
export default QuestionBankFooter;



// WEBPACK FOOTER //
// ./src/views/ESG/QuestionBank/QuestionBankFooter.jsx